import { mapActions, mapGetters } from 'vuex';
import globalConfig from '../utiles/globalConfig';
import { isStr, isFn, isObj } from '../utiles/judgeType';
const mainHost = globalConfig.getMainHost();
const UUID = 'uuid';

const FN_NAME = {
  fb: {
    switch: 'fbLogin',
    bind: 'fbBind',
    debind: 'fbDebind',
  },
  twi: {
    switch: 'twitterLogin',
    bind: 'twitterBind',
    debind: 'twitterDebind',
  },
  google: {
    switch: 'googleLogin',
    bind: 'googleBind',
    debind: 'googleDebind',
  },
  apple: {
    switch: '',
    bind: 'appleBind',
    debind: '',
  }
};

export default {
  data() {
    return {
      saveTwResolve: null,
      twiTimer: null,
      twiAction: '',
      appid: '',
      fbAction: '',
    };
  },
  computed: {
    ...mapGetters(['gameId', 'letter']),
  },
  methods: {
    getFingerprint() {
      return new Promise(resolve => {
        // 这里获取浏览器指纹（h5游戏），如果没有就返回空
        let saveUuid =
          globalConfig.getLclStorageItem(UUID) || globalConfig.getCookie(UUID);
        resolve(saveUuid || '');
      });
    },
    fbSdkInit(appid) {
      if (appid && isStr(appid)) {
        this.appid = appid;
        window.fbAsyncInit = function () {
          FB.init({
            appId: appid,
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v3.3',
            status: true,
          });
        };
        (function (d, s, id) {
          var js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            return;
          }
          js = d.createElement(s);
          js.id = id;
          js.src = `https://connect.facebook.net/en_US/sdk.js`;
          fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
      }
    },
    fbSdkLogin() {
      return new Promise((resolve, reject) => {
        FB.login(res => {
          if (res.status === 'connected') {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    fbSdkGetState() {
      return new Promise(resolve => {
        FB.getLoginStatus(res => {
          resolve(res);
        });
      });
    },
    fbAccountAction(type) {
      if (type) {
        this.fbAction = type;
      }
      let curFnName = type ? FN_NAME.fb[type] : FN_NAME.fb[this.fbAction];
      return this.fbSdkGetState().then(res => {
        if (res.status === 'connected') {
          return this[curFnName]({
            accessToken: res.authResponse.accessToken,
            appId: this.appid,
          });
        } else {
          return this.fbSdkLogin().then(
            this.fbAccountAction,
            this.authorizeFail
          );
        }
      });
    },
    startListenTwiAuthorize(winEle) {
      if (this.twiTimer) {
        clearInterval(this.twiTimer);
        this.twiTimer = null;
      }
      this.twiTimer = setInterval(() => {
        if (winEle.closed) {
          clearInterval(this.twiTimer);
          globalConfig.removeEventListener(this.excTwiAccountAction, 'message');
          this.twiTimer = null;
          if (isFn(this.saveTwResolve)) {
            this.saveTwResolve({
              result: '0',
              msg: this.letter.fb_canvas_login_fail,
            });
          }
        }
      }, 800);
    },
    excTwiAccountAction(e) {
      let res = e.data;
      if (isObj(res) && res.action === 'twCallback') {
        clearInterval(this.twiTimer);
        let curFnName = FN_NAME.twi[this.twiAction];
        return this[curFnName](res).then(res => {
          globalConfig.removeEventListener(this.excTwiAccountAction, 'message');
          if (isFn(this.saveTwResolve)) {
            this.saveTwResolve(res);
          }
        });
      }
    },
    twiAccountAction(type) {
      this.twiAction = type;
      globalConfig.addEvenListener(this.excTwiAccountAction, 'message');
      return new Promise(resolve => {
        // page参数指定postmessage发送的域名
        let twiPopup = window.open(
          `https://gpassport.${mainHost}/h5_twitter/auth?page=gabres&game_id=${this.gameId}`
        );
        this.saveTwResolve = resolve;
        this.startListenTwiAuthorize(twiPopup);
      });
    },
    googleSdkInit() {
      window.googleOnload = function () {
        gapi.load('auth2', function () {
          // 不用window的话ie11在h5的sdk用户中心切换的时候会没有权限
          window.googleAuth = gapi.auth2.init({
            client_id:
              '7516021564-c1fedmh49hglgd0dlagun73e506s0fjh.apps.googleusercontent.com',
            cookiepolicy: 'single_host_origin',
            scope: 'profile',
          });
        });
      };
      var js = document.getElementsByTagName('script')[0];
      var gjs = document.createElement('script');
      gjs.id = 'google-jssdk';
      gjs.src = 'https://apis.google.com/js/platform.js?onload=googleOnload';
      js.parentNode.insertBefore(gjs, js);
    },
    googleAccountAction(type) {
      let curFnName = FN_NAME.google[type];
      return window.googleAuth.signIn().then(res => {
        return this[curFnName]({
          idToken: res.getAuthResponse().id_token,
        });
      }, this.authorizeFail);
    },
    appleAccountAction(type) {
      let curFnName = FN_NAME.apple[type];
      if (!curFnName) Promise.reject();
      return this[curFnName]({
        bind: 'apple',
        forward: encodeURIComponent(window.location.href)
      });
    },
    mgAccountAction(params) {
      return this.mgLogin({
        code: params.extend,
        pw: params.pw,
      });
    },
    authorizeFail(e) {
      return new Promise(resolve => {
        resolve({
          result: '0',
          msg: this.letter.fb_canvas_login_fail,
        });
      });
    },
    ...mapActions([
      'fbLogin',
      'twitterLogin',
      'fbBind',
      'twitterBind',
      'googleLogin',
      'googleBind',
      'mgLogin',
      'fbDebind',
      'twitterDebind',
      'googleDebind',
      'appleBind'
    ])
  }
};
